import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import styles from 'src/styles/common.module.scss'

export const TextHeaderPt = () => {
    return (
        <HighlightedText
            text="PARABÉNS!"
            highlights={[{ word: 'PARABÉNS!' }]}
            className={styles.text_header}
        />
    )
}

export const TextContentPt = () => {
    return (
        <HighlightedText
            text="VOCÊ GANHOU 400 GIROS GRÁTIS"
            highlights={[
                { word: '400' },
                { word: 'GIROS' },
                { word: 'GRÁTIS' },
            ]}
            breakAfterWords={['GANHOU']}
            className={styles['text_content--SECOND']}
        />
    )
}
